import { ApiKey } from "../apiKeys";
import { authAxios } from "../config";
import { ProfileType } from "../../types/userTypes";
import { checkTokenValidation } from "../auth/tokenReq";

export const get_eAdminListReq = async () => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": eAdminReq->get_eAdminListReq " + t
    );
  try {
    await checkTokenValidation();

    const res = await authAxios.get(`${ApiKey.get_eAdminListKey}`);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const cepData = resData?.Employees || [];
    const _data = cepData?.map((item: any) => ({
      user: {
        userID: item?.user?.userID || "",
        email: item?.user?.email || "",
        mobileNumber: item?.user?.mobileNumber || "",
      },
      employee: {
        employeeID: item?.employee?.employeeID || "",
        firstName: item?.employee?.firstName || "",
        lastName: item?.employee?.lastName || "",
        designation: item?.employee?.designation || "",
        workLocation: item?.employee?.workLocation || "",
        createdAt: item?.employee?.createdAt || "",
        updatedAt: item?.employee?.updatedAt || "",
        companyID: item?.employee?.companyID || "",
        userID: item?.employee?.userID || "",
        CEPPartnerID: item?.employee?.CEPPartnerID || "",
      },
      company: {
        comapnyID: item?.company?.comapnyID || "",
        CompanyName: item?.company?.CompanyName || "",
      },
    }));
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};

type createCEPAdminDataProp = {
  CompanyName: string;
  mobileNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  designation: string;
  CEPPartnerID: number;
};

export const createNewEAdminReq = async (data: createCEPAdminDataProp) => {
  const logfun = (d: any, t: string) =>
    console.log(
      JSON.stringify(d, null, 2),
      new Date() + ": eAdminReq->createNewEAdminReq " + t
    );
  try {
    await checkTokenValidation();
    const body = data;

    const res = await authAxios.post(`${ApiKey.createEAminKey}`, body);
    // logfun(res.data, "res");
    const resData = res.data;
    const _msg = resData.message || "";
    const _data = null;
    return { error: false, data: _data, message: _msg, errorMsg: "" };
  } catch (err: any) {
    let error;
    if (err.response) error = err.response.data.message || "Response error";
    else if (err.request) error = "Request error" || err.request;
    else error = "Something went wrong please try again later";
    // logfun(error, "ERROR");
    throw { error: true, data: "", message: "", errorMsg: error };
  }
};
